import {globalWindow} from '../../libs/shared/core/src/helpers/browser/browserHelpers';
import {CancelToken} from '../../libs/shared/core/src/helpers/utilities/asyncCancelHelpers';
import {
  delayAsync as defaultDelayAsync,
  TimeoutCallback,
  withTimeoutAsync as defaultWithTimeoutAsync,
} from '../../libs/shared/core/src/helpers/utilities/asyncHelpers';
import {computeDelayWithJitter} from '../../libs/shared/core/src/helpers/utilities/exponentialBackoffHelpers';

export function delayAsync(delay: number = 0, cancelToken?: CancelToken): Promise<void> {
  return defaultDelayAsync(globalWindow, delay, cancelToken);
}

/*
 * Timeout.
 */

export async function withTimeoutAsync<T>(
  callback: () => Promise<T>,
  timeout: number,
  timeoutCallback?: TimeoutCallback<T>,
): Promise<T> {
  return defaultWithTimeoutAsync(globalWindow, callback, timeout, timeoutCallback);
}

/*
 * Jitter.
 */

export function delayWithJitterAsync(delay: number, jitterWeight: number, cancelToken?: CancelToken) {
  return delayAsync(computeDelayWithJitter(delay, jitterWeight), cancelToken);
}
